import qsa from "1dr-utils/helpers/elsForEach";
import { InputErrors } from "@/js/libs/form-errors";

export default () => {
  let _uid = +new Date();
  const getUid = () => {
    _uid++;
    return _uid;
  };

  qsa("[data-repeating-fields-container]", (container) => {
    const targetName = container.getAttribute(
      "data-repeating-fields-container",
    );
    let target;
    if (targetName) {
      target = container.querySelector(`[name="${targetName}"]`);
    }

    const existingInputs = container.querySelectorAll("[data-repeating-field]");
    const newRow = document.querySelector("button[data-new-row]");

    const template = container.querySelector("[data-template]");

    const errorHandlers = [];

    const getEmails = () => {
      const nodes = container.querySelectorAll("[data-repeating-field] input");
      let string = "";

      qsa(nodes, (input) => {
        string = `${string}\n${input.value}`;
      });

      const foundEmails = [];

      errorHandlers.forEach((handler) => {
        if (handler.element.value.trim()) {
          if (handler.validate(false)) {
            foundEmails.push(handler.element.value);
          }
        }
      });

      if (target) {
        target.value = foundEmails.join("\n");
      }
    };

    const fixLabels = () => {
      const nodes = container.querySelectorAll("[data-repeating-field]");

      qsa(nodes, (node, i) => {
        const label = node.querySelector("label");
        if (label) {
          label.innerHTML = `Guest Email ${i + 1}:`;
        }
      });
    };

    let timer;
    const listener = (div) => {
      const input = div.querySelector("input");
      const remove = div.querySelector("button");

      const errorHandler = new InputErrors(input);
      const i = errorHandlers.push(errorHandler) - 1;

      input.addEventListener("input", () => {
        clearTimeout(timer);
        getEmails();
        timer = setTimeout(() => {
          errorHandler.validate(true);
        }, 500);
      });

      remove.addEventListener("click", () => {
        div.remove();
        errorHandlers.splice(i, 1);
        fixLabels();
        getEmails();
      });
    };

    if (newRow) {
      newRow.addEventListener("click", (e) => {
        e.preventDefault();
        const nodes = container.querySelectorAll("[data-repeating-field]");

        const div = document.createElement("div");
        div.setAttribute("data-repeating-field", "data-repeating-field");
        div.setAttribute("class", "flex my-6");
        div.innerHTML = template.innerHTML.trim();

        const input = div.querySelector("input");
        const label = div.querySelector("label");

        const uid = getUid();
        input.setAttribute("name", `email-${uid}`);
        input.setAttribute("id", `repeating-email-${uid}`);
        label.setAttribute("for", `repeating-email-${uid}`);
        label.innerHTML = `Guest Email ${nodes.length + 1}`;

        container.appendChild(div);

        listener(div);
        fixLabels();
      });
    }

    qsa(existingInputs, listener);
  });
};
